;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Link from "next/link"
const linkClass = "text-[16px] font-roboto font-light text-blue-accent-2"

function SecondaryLinkContainer({ text, href }: { text: string; href: string }) {
  return (
    <Link href={href} className={linkClass}>
      {text}
    </Link>
  )
}

export default SecondaryLinkContainer
